"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailMode = exports.DetailToolbarButtonType = void 0;
/**
 * Toolbar button type.
 */
var DetailToolbarButtonType;
(function (DetailToolbarButtonType) {
    DetailToolbarButtonType[DetailToolbarButtonType["NORMAL"] = 0] = "NORMAL";
    DetailToolbarButtonType[DetailToolbarButtonType["PRIMARY"] = 1] = "PRIMARY";
    DetailToolbarButtonType[DetailToolbarButtonType["SECONDARY"] = 2] = "SECONDARY";
})(DetailToolbarButtonType = exports.DetailToolbarButtonType || (exports.DetailToolbarButtonType = {}));
var DetailMode;
(function (DetailMode) {
    DetailMode[DetailMode["NONE"] = 0] = "NONE";
    DetailMode[DetailMode["VIEW"] = 1] = "VIEW";
    DetailMode[DetailMode["EDIT"] = 2] = "EDIT";
    DetailMode[DetailMode["NEW"] = 3] = "NEW";
})(DetailMode = exports.DetailMode || (exports.DetailMode = {}));
//# sourceMappingURL=detail-types.js.map